import { defineMessages } from "react-intl"

export const editableEquipmentListMessages = defineMessages({
	addCustomEquipment: {
		defaultMessage: "Add Custom Equipment",
		id: "equipment.addCustomEquipment",
	},
	equipmentCategory: {
		defaultMessage: "Category",
		id: "equipment.category",
	},
	equipmentCode: {
		defaultMessage: "Code",
		id: "equipment.code",
	},
	equipmentName: {
		defaultMessage: "Name",
		id: "equipment.name",
	},
	onlyVisibleInternally: {
		defaultMessage: "only visible internally",
		id: "equipment.onlyVisibleInternally",
	},
	otherEquipmentTitle: {
		defaultMessage: "Other Equipment",
		id: "equipment.otherTitle",
	},
	resetToFactoryEquipment: {
		defaultMessage: "Reset to factory equipment",
		id: "equipment.resetToFactoryEquipment",
	},
	resetToFactoryEquipmentConfirmationText: {
		defaultMessage:
			// eslint-disable-next-line formatjs/prefer-full-sentence
			"Are you sure you want to revert to factory equipment?{linebreak}{linebreak}" +
			"All equipment options you manually added will be removed.{linebreak}All factory options you previously removed will be added back in.",
		id: "equipment.resetToFactoryEquipmentConfirmationText",
	},
})
